import * as constAction from 'root/actionConstants';

export const clear = value => ({
  type: constAction.GRUPOS_CLEAR,
  payload: value,
});

export const setState = values => ({
  type: constAction.GRUPOS_SET_STATE,
  payload: values,
});

export const modificarUsuariosGrupo = (usuario) => ({
  type: constAction.GRUPOS_MODIFICAR_USUARIOS_STATE,
  payload: { usuario },
});

export const get = () => ({
  type: constAction.GRUPOS_GET,
  epic: {
    url: 'grupos/getList',
    method: 'GET',
  },
});

export const getById = grupoId => ({
  type: constAction.GRUPOS_GET_BY_ID,
  payload: { grupoId },
  epic: {
    url: 'grupos/getFull',
    method: 'GET',
  },
});

export const set = data => ({
  type: constAction.GRUPOS_SET,
  payload: {
    ...data,
  },
  epic: {
    url: data.grupoId ? 'grupos/modificar' : 'grupos/crear',
    method: 'POST',
  },
});

export const delete_ = grupoId => ({
  type: constAction.GRUPOS_DELETE,
  payload: { grupoId },
  epic: {
    url: 'grupos/eliminar',
    method: 'POST',
  },
});

export const modificarUsuarios = (usuarioId, grupoId) => ({
  type: constAction.GRUPOS_MODIFICAR_USUARIOS,
  payload: { usuarioId, grupoId },
  epic: {
    url: 'grupos/agregarUsuario',
    method: 'POST',
  },
});

export const deleteUsuario = (usuariosId, grupoId) => ({
  type: constAction.GRUPOS_DELETE_USUARIO,
  payload: { usuariosId, grupoId },
  epic: {
    url: 'grupos/removerUsuario',
    method: 'POST',
  },
});



// WEBPACK FOOTER //
// src/modules/grupos/action.js